import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import Moment from 'react-moment';

// import { addOrder, listOrders, orderActiveId } from '../actions/order';
import { SelectPicker } from 'rsuite';
import OrderAdd from './OrderAdd';
import OrderDetails from './OrderDetails';



import Map, {Source, Layer, Popup, FullscreenControl, NavigationControl, ScaleControl, Marker} from 'react-map-gl/mapbox';

import 'mapbox-gl/dist/mapbox-gl.css';

var z = 0


class WorkMap extends React.Component {

  constructor() {
      super();
      this.state = {
          name: '',
          errors: {},
          list: [],
          currentorg: '',
          showPopup: false,
          hoverInfo: false,
          points: [
            {
                "lat": 51.1456783,
                "lng": 17.0692733,
                "odometer": 10596870,
                "timestamp": 1742798636
            },
            {
                "lat": 51.1456566,
                "lng": 17.0693366,
                "odometer": 10596870,
                "timestamp": 1742798678
            },
            {
                "lat": 51.1456566,
                "lng": 17.0693366,
                "odometer": 10596870,
                "timestamp": 1742798679
            },
            {
                "lat": 51.1456566,
                "lng": 17.0693366,
                "odometer": 10596870,
                "timestamp": 1742798684
            },
            {
                "lat": 51.1456566,
                "lng": 17.0693366,
                "odometer": 10596870,
                "timestamp": 1742798689
            },
            {
                "lat": 51.1456983,
                "lng": 17.06947,
                "odometer": 10596870,
                "timestamp": 1742798694
            },
            {
                "lat": 51.1457333,
                "lng": 17.0694633,
                "odometer": 10596870,
                "timestamp": 1742798699
            },
            {
                "lat": 51.14573,
                "lng": 17.0694966,
                "odometer": 10596870,
                "timestamp": 1742798704
            },
            {
                "lat": 51.1457349,
                "lng": 17.0695016,
                "odometer": 10596870,
                "timestamp": 1742798709
            },
            {
                "lat": 51.1457349,
                "lng": 17.0695016,
                "odometer": 10596870,
                "timestamp": 1742798714
            },
            {
                "lat": 51.1457083,
                "lng": 17.0695233,
                "odometer": 10596876,
                "timestamp": 1742798716
            },
            {
                "lat": 51.1457033,
                "lng": 17.0698633,
                "odometer": 10596900,
                "timestamp": 1742798721
            },
            {
                "lat": 51.1457483,
                "lng": 17.0702783,
                "odometer": 10596929,
                "timestamp": 1742798726
            },
            {
                "lat": 51.1457666,
                "lng": 17.0705733,
                "odometer": 10596948,
                "timestamp": 1742798731
            },
            {
                "lat": 51.1457733,
                "lng": 17.070895,
                "odometer": 10596973,
                "timestamp": 1742798736
            },
            {
                "lat": 51.1458016,
                "lng": 17.0712566,
                "odometer": 10596999,
                "timestamp": 1742798741
            },
            {
                "lat": 51.1458316,
                "lng": 17.07148,
                "odometer": 10597015,
                "timestamp": 1742798744
            },
            {
                "lat": 51.145855,
                "lng": 17.0715166,
                "odometer": 10597019,
                "timestamp": 1742798745
            },
            {
                "lat": 51.1458899,
                "lng": 17.071535,
                "odometer": 10597023,
                "timestamp": 1742798746
            },
            {
                "lat": 51.1460883,
                "lng": 17.0715916,
                "odometer": 10597046,
                "timestamp": 1742798751
            },
            {
                "lat": 51.14633,
                "lng": 17.0715916,
                "odometer": 10597073,
                "timestamp": 1742798756
            },
            {
                "lat": 51.1465383,
                "lng": 17.0716616,
                "odometer": 10597097,
                "timestamp": 1742798759
            },
            {
                "lat": 51.1466116,
                "lng": 17.0716633,
                "odometer": 10597102,
                "timestamp": 1742798764
            },
            {
                "lat": 51.1466116,
                "lng": 17.0716633,
                "odometer": 10597105,
                "timestamp": 1742798766
            },
            {
                "lat": 51.1466349,
                "lng": 17.0716983,
                "odometer": 10597109,
                "timestamp": 1742798767
            },
            {
                "lat": 51.1466283,
                "lng": 17.0717666,
                "odometer": 10597114,
                "timestamp": 1742798772
            },
            {
                "lat": 51.1466033,
                "lng": 17.0718516,
                "odometer": 10597120,
                "timestamp": 1742798777
            },
            {
                "lat": 51.1464133,
                "lng": 17.0722516,
                "odometer": 10597155,
                "timestamp": 1742798782
            },
            {
                "lat": 51.1462316,
                "lng": 17.0727316,
                "odometer": 10597194,
                "timestamp": 1742798787
            },
            {
                "lat": 51.1461383,
                "lng": 17.07294,
                "odometer": 10597212,
                "timestamp": 1742798792
            },
            {
                "lat": 51.1460783,
                "lng": 17.0730766,
                "odometer": 10597224,
                "timestamp": 1742798797
            },
            {
                "lat": 51.1460283,
                "lng": 17.073175,
                "odometer": 10597233,
                "timestamp": 1742798800
            },
            {
                "lat": 51.1459966,
                "lng": 17.0731966,
                "odometer": 10597237,
                "timestamp": 1742798801
            },
            {
                "lat": 51.1459566,
                "lng": 17.0732,
                "odometer": 10597241,
                "timestamp": 1742798802
            },
            {
                "lat": 51.1458516,
                "lng": 17.0731366,
                "odometer": 10597254,
                "timestamp": 1742798804
            },
            {
                "lat": 51.1455066,
                "lng": 17.0728616,
                "odometer": 10597297,
                "timestamp": 1742798809
            },
            {
                "lat": 51.1451333,
                "lng": 17.0725566,
                "odometer": 10597343,
                "timestamp": 1742798814
            },
            {
                "lat": 51.1448033,
                "lng": 17.0722749,
                "odometer": 10597385,
                "timestamp": 1742798819
            },
            {
                "lat": 51.1444866,
                "lng": 17.07202,
                "odometer": 10597424,
                "timestamp": 1742798824
            },
            {
                "lat": 51.1441966,
                "lng": 17.0717866,
                "odometer": 10597460,
                "timestamp": 1742798829
            },
            {
                "lat": 51.143895,
                "lng": 17.0715449,
                "odometer": 10597498,
                "timestamp": 1742798834
            },
            {
                "lat": 51.1436033,
                "lng": 17.0713016,
                "odometer": 10597534,
                "timestamp": 1742798839
            },
            {
                "lat": 51.143305,
                "lng": 17.0710933,
                "odometer": 10597571,
                "timestamp": 1742798844
            },
            {
                "lat": 51.143085,
                "lng": 17.0710083,
                "odometer": 10597596,
                "timestamp": 1742798849
            },
            {
                "lat": 51.1429733,
                "lng": 17.0709816,
                "odometer": 10597605,
                "timestamp": 1742798854
            },
            {
                "lat": 51.1429133,
                "lng": 17.070965,
                "odometer": 10597613,
                "timestamp": 1742798859
            },
            {
                "lat": 51.1428099,
                "lng": 17.0709433,
                "odometer": 10597624,
                "timestamp": 1742798864
            },
            {
                "lat": 51.1427333,
                "lng": 17.0709183,
                "odometer": 10597635,
                "timestamp": 1742798869
            },
            {
                "lat": 51.14231,
                "lng": 17.0708333,
                "odometer": 10597683,
                "timestamp": 1742798874
            },
            {
                "lat": 51.1417883,
                "lng": 17.0706833,
                "odometer": 10597742,
                "timestamp": 1742798879
            },
            {
                "lat": 51.1413133,
                "lng": 17.0705466,
                "odometer": 10597795,
                "timestamp": 1742798884
            },
            {
                "lat": 51.1411366,
                "lng": 17.0704666,
                "odometer": 10597816,
                "timestamp": 1742798889
            },
            {
                "lat": 51.1410616,
                "lng": 17.07042,
                "odometer": 10597825,
                "timestamp": 1742798894
            },
            {
                "lat": 51.1410033,
                "lng": 17.0703933,
                "odometer": 10597828,
                "timestamp": 1742798899
            },
            {
                "lat": 51.140875,
                "lng": 17.0703,
                "odometer": 10597847,
                "timestamp": 1742798904
            },
            {
                "lat": 51.1404166,
                "lng": 17.070075,
                "odometer": 10597901,
                "timestamp": 1742798909
            },
            {
                "lat": 51.140155,
                "lng": 17.0698833,
                "odometer": 10597933,
                "timestamp": 1742798913
            },
            {
                "lat": 51.1401416,
                "lng": 17.0697916,
                "odometer": 10597940,
                "timestamp": 1742798914
            },
            {
                "lat": 51.1401499,
                "lng": 17.0696983,
                "odometer": 10597946,
                "timestamp": 1742798915
            },
            {
                "lat": 51.1401899,
                "lng": 17.0695133,
                "odometer": 10597960,
                "timestamp": 1742798917
            },
            {
                "lat": 51.1403516,
                "lng": 17.0690033,
                "odometer": 10598000,
                "timestamp": 1742798922
            },
            {
                "lat": 51.1405183,
                "lng": 17.0684466,
                "odometer": 10598043,
                "timestamp": 1742798927
            },
            {
                "lat": 51.1407033,
                "lng": 17.0678583,
                "odometer": 10598089,
                "timestamp": 1742798932
            },
            {
                "lat": 51.1408983,
                "lng": 17.0672333,
                "odometer": 10598137,
                "timestamp": 1742798937
            },
            {
                "lat": 51.1410983,
                "lng": 17.0666033,
                "odometer": 10598187,
                "timestamp": 1742798942
            },
            {
                "lat": 51.1413083,
                "lng": 17.0659649,
                "odometer": 10598237,
                "timestamp": 1742798947
            },
            {
                "lat": 51.1415133,
                "lng": 17.065305,
                "odometer": 10598288,
                "timestamp": 1742798952
            },
            {
                "lat": 51.1417183,
                "lng": 17.0645666,
                "odometer": 10598345,
                "timestamp": 1742798957
            },
            {
                "lat": 51.1419499,
                "lng": 17.0638933,
                "odometer": 10598399,
                "timestamp": 1742798962
            },
            {
                "lat": 51.1420283,
                "lng": 17.06357,
                "odometer": 10598424,
                "timestamp": 1742798966
            },
            {
                "lat": 51.1420016,
                "lng": 17.063495,
                "odometer": 10598430,
                "timestamp": 1742798967
            },
            {
                "lat": 51.1418033,
                "lng": 17.0632449,
                "odometer": 10598458,
                "timestamp": 1742798970
            },
            {
                "lat": 51.1414716,
                "lng": 17.062885,
                "odometer": 10598505,
                "timestamp": 1742798975
            },
            {
                "lat": 51.1411616,
                "lng": 17.0624816,
                "odometer": 10598550,
                "timestamp": 1742798980
            },
            {
                "lat": 51.140905,
                "lng": 17.0621316,
                "odometer": 10598587,
                "timestamp": 1742798985
            },
            {
                "lat": 51.1407333,
                "lng": 17.061935,
                "odometer": 10598611,
                "timestamp": 1742798990
            },
            {
                "lat": 51.1407066,
                "lng": 17.061915,
                "odometer": 10598611,
                "timestamp": 1742798995
            },
            {
                "lat": 51.1406716,
                "lng": 17.061875,
                "odometer": 10598619,
                "timestamp": 1742798997
            },
            {
                "lat": 51.1406366,
                "lng": 17.06174,
                "odometer": 10598630,
                "timestamp": 1742798999
            },
            {
                "lat": 51.140645,
                "lng": 17.061635,
                "odometer": 10598637,
                "timestamp": 1742799000
            },
            {
                "lat": 51.140735,
                "lng": 17.0612233,
                "odometer": 10598667,
                "timestamp": 1742799003
            },
            {
                "lat": 51.14095,
                "lng": 17.0603966,
                "odometer": 10598730,
                "timestamp": 1742799008
            },
            {
                "lat": 51.1411416,
                "lng": 17.0595483,
                "odometer": 10598793,
                "timestamp": 1742799013
            },
            {
                "lat": 51.1413666,
                "lng": 17.0586816,
                "odometer": 10598858,
                "timestamp": 1742799018
            },
            {
                "lat": 51.1415166,
                "lng": 17.0580416,
                "odometer": 10598906,
                "timestamp": 1742799023
            },
            {
                "lat": 51.1416316,
                "lng": 17.0575933,
                "odometer": 10598940,
                "timestamp": 1742799028
            },
            {
                "lat": 51.141825,
                "lng": 17.0568,
                "odometer": 10598999,
                "timestamp": 1742799033
            },
            {
                "lat": 51.1419349,
                "lng": 17.0561966,
                "odometer": 10599043,
                "timestamp": 1742799038
            },
            {
                "lat": 51.1419116,
                "lng": 17.05611,
                "odometer": 10599050,
                "timestamp": 1742799039
            },
            {
                "lat": 51.14186,
                "lng": 17.0560216,
                "odometer": 10599058,
                "timestamp": 1742799040
            },
            {
                "lat": 51.1415549,
                "lng": 17.0556649,
                "odometer": 10599101,
                "timestamp": 1742799045
            },
            {
                "lat": 51.1413616,
                "lng": 17.055255,
                "odometer": 10599137,
                "timestamp": 1742799048
            },
            {
                "lat": 51.1411,
                "lng": 17.054555,
                "odometer": 10599193,
                "timestamp": 1742799053
            },
            {
                "lat": 51.141045,
                "lng": 17.0543333,
                "odometer": 10599209,
                "timestamp": 1742799057
            },
            {
                "lat": 51.1410666,
                "lng": 17.0543183,
                "odometer": 10599212,
                "timestamp": 1742799058
            },
            {
                "lat": 51.1411016,
                "lng": 17.0542966,
                "odometer": 10599217,
                "timestamp": 1742799059
            },
            {
                "lat": 51.141425,
                "lng": 17.0542066,
                "odometer": 10599253,
                "timestamp": 1742799064
            },
            {
                "lat": 51.1415383,
                "lng": 17.0541466,
                "odometer": 10599266,
                "timestamp": 1742799066
            },
            {
                "lat": 51.1416216,
                "lng": 17.054015,
                "odometer": 10599280,
                "timestamp": 1742799068
            },
            {
                "lat": 51.1416649,
                "lng": 17.0537216,
                "odometer": 10599301,
                "timestamp": 1742799070
            },
            {
                "lat": 51.14176,
                "lng": 17.0529199,
                "odometer": 10599358,
                "timestamp": 1742799075
            },
            {
                "lat": 51.1416816,
                "lng": 17.0520516,
                "odometer": 10599419,
                "timestamp": 1742799080
            },
            {
                "lat": 51.1416016,
                "lng": 17.0510983,
                "odometer": 10599486,
                "timestamp": 1742799085
            },
            {
                "lat": 51.1415616,
                "lng": 17.0502783,
                "odometer": 10599544,
                "timestamp": 1742799090
            },
            {
                "lat": 51.1415216,
                "lng": 17.0498283,
                "odometer": 10599576,
                "timestamp": 1742799095
            },
            {
                "lat": 51.1415033,
                "lng": 17.0497433,
                "odometer": 10599582,
                "timestamp": 1742799099
            },
            {
                "lat": 51.1414466,
                "lng": 17.049215,
                "odometer": 10599620,
                "timestamp": 1742799104
            },
            {
                "lat": 51.1413733,
                "lng": 17.04854,
                "odometer": 10599667,
                "timestamp": 1742799109
            },
            {
                "lat": 51.1413083,
                "lng": 17.0476466,
                "odometer": 10599731,
                "timestamp": 1742799114
            },
            {
                "lat": 51.1412583,
                "lng": 17.0472216,
                "odometer": 10599761,
                "timestamp": 1742799119
            },
            {
                "lat": 51.14124,
                "lng": 17.0469483,
                "odometer": 10599777,
                "timestamp": 1742799124
            },
            {
                "lat": 51.14124,
                "lng": 17.0469483,
                "odometer": 10599777,
                "timestamp": 1742799129
            },
            {
                "lat": 51.14124,
                "lng": 17.0469483,
                "odometer": 10599777,
                "timestamp": 1742799134
            },
            {
                "lat": 51.14124,
                "lng": 17.0469483,
                "odometer": 10599777,
                "timestamp": 1742799139
            },
            {
                "lat": 51.14124,
                "lng": 17.0469483,
                "odometer": 10599777,
                "timestamp": 1742799144
            },
            {
                "lat": 51.1412299,
                "lng": 17.0468133,
                "odometer": 10599790,
                "timestamp": 1742799149
            },
            {
                "lat": 51.1411683,
                "lng": 17.0460516,
                "odometer": 10599843,
                "timestamp": 1742799154
            },
            {
                "lat": 51.1410883,
                "lng": 17.04506,
                "odometer": 10599913,
                "timestamp": 1742799159
            },
            {
                "lat": 51.1410049,
                "lng": 17.0444916,
                "odometer": 10599954,
                "timestamp": 1742799164
            },
            {
                "lat": 51.1409933,
                "lng": 17.0443083,
                "odometer": 10599967,
                "timestamp": 1742799169
            },
            {
                "lat": 51.140925,
                "lng": 17.04355,
                "odometer": 10600021,
                "timestamp": 1742799174
            },
            {
                "lat": 51.1408883,
                "lng": 17.0430383,
                "odometer": 10600057,
                "timestamp": 1742799179
            },
            {
                "lat": 51.14086,
                "lng": 17.0427283,
                "odometer": 10600077,
                "timestamp": 1742799184
            },
            {
                "lat": 51.1408333,
                "lng": 17.0424216,
                "odometer": 10600100,
                "timestamp": 1742799189
            },
            {
                "lat": 51.14074,
                "lng": 17.0414183,
                "odometer": 10600171,
                "timestamp": 1742799194
            },
            {
                "lat": 51.1406699,
                "lng": 17.0408116,
                "odometer": 10600215,
                "timestamp": 1742799199
            },
            {
                "lat": 51.1405966,
                "lng": 17.0407733,
                "odometer": 10600223,
                "timestamp": 1742799200
            },
            {
                "lat": 51.1405266,
                "lng": 17.04076,
                "odometer": 10600231,
                "timestamp": 1742799201
            },
            {
                "lat": 51.1403183,
                "lng": 17.0408066,
                "odometer": 10600255,
                "timestamp": 1742799203
            },
            {
                "lat": 51.1401233,
                "lng": 17.040805,
                "odometer": 10600277,
                "timestamp": 1742799206
            },
            {
                "lat": 51.1401033,
                "lng": 17.040725,
                "odometer": 10600283,
                "timestamp": 1742799207
            },
            {
                "lat": 51.1400899,
                "lng": 17.0406216,
                "odometer": 10600290,
                "timestamp": 1742799208
            },
            {
                "lat": 51.1400016,
                "lng": 17.0404183,
                "odometer": 10600308,
                "timestamp": 1742799211
            },
            {
                "lat": 51.1399416,
                "lng": 17.0404233,
                "odometer": 10600315,
                "timestamp": 1742799212
            },
            {
                "lat": 51.1393966,
                "lng": 17.04057,
                "odometer": 10600376,
                "timestamp": 1742799217
            },
            {
                "lat": 51.1392416,
                "lng": 17.0405483,
                "odometer": 10600394,
                "timestamp": 1742799219
            },
            {
                "lat": 51.1391983,
                "lng": 17.04048,
                "odometer": 10600401,
                "timestamp": 1742799220
            },
            {
                "lat": 51.13909,
                "lng": 17.0400699,
                "odometer": 10600432,
                "timestamp": 1742799222
            },
            {
                "lat": 51.138805,
                "lng": 17.0392966,
                "odometer": 10600495,
                "timestamp": 1742799227
            },
            {
                "lat": 51.1385866,
                "lng": 17.0385366,
                "odometer": 10600554,
                "timestamp": 1742799232
            },
            {
                "lat": 51.1384799,
                "lng": 17.0383133,
                "odometer": 10600573,
                "timestamp": 1742799235
            },
            {
                "lat": 51.13844,
                "lng": 17.0382933,
                "odometer": 10600578,
                "timestamp": 1742799236
            },
            {
                "lat": 51.1383333,
                "lng": 17.038295,
                "odometer": 10600590,
                "timestamp": 1742799238
            },
            {
                "lat": 51.1377033,
                "lng": 17.03849,
                "odometer": 10600661,
                "timestamp": 1742799243
            },
            {
                "lat": 51.1370333,
                "lng": 17.038645,
                "odometer": 10600736,
                "timestamp": 1742799248
            },
            {
                "lat": 51.1364683,
                "lng": 17.0388083,
                "odometer": 10600800,
                "timestamp": 1742799253
            },
            {
                "lat": 51.1362233,
                "lng": 17.038875,
                "odometer": 10600826,
                "timestamp": 1742799258
            },
            {
                "lat": 51.1362083,
                "lng": 17.0388766,
                "odometer": 10600830,
                "timestamp": 1742799263
            },
            {
                "lat": 51.1359633,
                "lng": 17.0389566,
                "odometer": 10600857,
                "timestamp": 1742799268
            },
            {
                "lat": 51.1357383,
                "lng": 17.038995,
                "odometer": 10600883,
                "timestamp": 1742799273
            },
            {
                "lat": 51.135465,
                "lng": 17.039065,
                "odometer": 10600913,
                "timestamp": 1742799278
            },
            {
                "lat": 51.135165,
                "lng": 17.0391383,
                "odometer": 10600947,
                "timestamp": 1742799283
            },
            {
                "lat": 51.1348866,
                "lng": 17.0391799,
                "odometer": 10600978,
                "timestamp": 1742799288
            },
            {
                "lat": 51.1347883,
                "lng": 17.039165,
                "odometer": 10600989,
                "timestamp": 1742799290
            },
            {
                "lat": 51.1347583,
                "lng": 17.0391366,
                "odometer": 10600993,
                "timestamp": 1742799291
            },
            {
                "lat": 51.1347099,
                "lng": 17.0390183,
                "odometer": 10601003,
                "timestamp": 1742799293
            },
            {
                "lat": 51.13469,
                "lng": 17.03883,
                "odometer": 10601016,
                "timestamp": 1742799295
            },
            {
                "lat": 51.1346566,
                "lng": 17.03833,
                "odometer": 10601051,
                "timestamp": 1742799300
            },
            {
                "lat": 51.1346,
                "lng": 17.0379099,
                "odometer": 10601081,
                "timestamp": 1742799305
            },
            {
                "lat": 51.1345533,
                "lng": 17.0376333,
                "odometer": 10601102,
                "timestamp": 1742799310
            },
            {
                "lat": 51.1344916,
                "lng": 17.0369916,
                "odometer": 10601147,
                "timestamp": 1742799315
            },
            {
                "lat": 51.13446,
                "lng": 17.0367133,
                "odometer": 10601166,
                "timestamp": 1742799320
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799325
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799330
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799335
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799340
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799345
            },
            {
                "lat": 51.13446,
                "lng": 17.0367366,
                "odometer": 10601166,
                "timestamp": 1742799350
            },
            {
                "lat": 51.134445,
                "lng": 17.0367433,
                "odometer": 10601166,
                "timestamp": 1742799353
            },
            {
                "lat": 51.1344483,
                "lng": 17.0365033,
                "odometer": 10601181,
                "timestamp": 1742799356
            },
            {
                "lat": 51.1344233,
                "lng": 17.0364166,
                "odometer": 10601188,
                "timestamp": 1742799357
            },
            {
                "lat": 51.134375,
                "lng": 17.03635,
                "odometer": 10601195,
                "timestamp": 1742799358
            },
            {
                "lat": 51.1341099,
                "lng": 17.0361733,
                "odometer": 10601227,
                "timestamp": 1742799363
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799368
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799373
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799378
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799383
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799388
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799393
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799398
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799403
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799408
            },
            {
                "lat": 51.1341,
                "lng": 17.0361666,
                "odometer": 10601227,
                "timestamp": 1742799413
            },
            {
                "lat": 51.1340116,
                "lng": 17.036115,
                "odometer": 10601239,
                "timestamp": 1742799418
            },
            {
                "lat": 51.133615,
                "lng": 17.0360016,
                "odometer": 10601284,
                "timestamp": 1742799422
            },
            {
                "lat": 51.1330583,
                "lng": 17.036245,
                "odometer": 10601348,
                "timestamp": 1742799427
            },
            {
                "lat": 51.1324516,
                "lng": 17.036575,
                "odometer": 10601420,
                "timestamp": 1742799432
            },
            {
                "lat": 51.1318249,
                "lng": 17.036925,
                "odometer": 10601493,
                "timestamp": 1742799437
            },
            {
                "lat": 51.1313816,
                "lng": 17.0371833,
                "odometer": 10601546,
                "timestamp": 1742799442
            },
            {
                "lat": 51.1311816,
                "lng": 17.0372599,
                "odometer": 10601569,
                "timestamp": 1742799445
            },
            {
                "lat": 51.1309166,
                "lng": 17.0372133,
                "odometer": 10601599,
                "timestamp": 1742799450
            },
            {
                "lat": 51.1306416,
                "lng": 17.03713,
                "odometer": 10601630,
                "timestamp": 1742799455
            },
            {
                "lat": 51.1302616,
                "lng": 17.037005,
                "odometer": 10601673,
                "timestamp": 1742799460
            },
            {
                "lat": 51.130125,
                "lng": 17.03699,
                "odometer": 10601688,
                "timestamp": 1742799463
            },
            {
                "lat": 51.1300999,
                "lng": 17.0369916,
                "odometer": 10601688,
                "timestamp": 1742799468
            },
            {
                "lat": 51.1300849,
                "lng": 17.037015,
                "odometer": 10601693,
                "timestamp": 1742799472
            },
            {
                "lat": 51.1300533,
                "lng": 17.0371399,
                "odometer": 10601702,
                "timestamp": 1742799474
            },
            {
                "lat": 51.1300183,
                "lng": 17.0379566,
                "odometer": 10601760,
                "timestamp": 1742799479
            },
            {
                "lat": 51.1299349,
                "lng": 17.0387283,
                "odometer": 10601814,
                "timestamp": 1742799484
            },
            {
                "lat": 51.1298766,
                "lng": 17.03945,
                "odometer": 10601865,
                "timestamp": 1742799489
            },
            {
                "lat": 51.1297616,
                "lng": 17.0401783,
                "odometer": 10601918,
                "timestamp": 1742799494
            },
            {
                "lat": 51.12974,
                "lng": 17.0405449,
                "odometer": 10601943,
                "timestamp": 1742799497
            },
            {
                "lat": 51.1298333,
                "lng": 17.0411466,
                "odometer": 10601987,
                "timestamp": 1742799502
            },
            {
                "lat": 51.1299416,
                "lng": 17.0416933,
                "odometer": 10602027,
                "timestamp": 1742799507
            },
            {
                "lat": 51.1300049,
                "lng": 17.0419449,
                "odometer": 10602046,
                "timestamp": 1742799512
            },
            {
                "lat": 51.1301183,
                "lng": 17.0423383,
                "odometer": 10602076,
                "timestamp": 1742799517
            },
            {
                "lat": 51.1302499,
                "lng": 17.0427783,
                "odometer": 10602110,
                "timestamp": 1742799522
            },
            {
                "lat": 51.1303633,
                "lng": 17.0431483,
                "odometer": 10602139,
                "timestamp": 1742799527
            },
            {
                "lat": 51.13048,
                "lng": 17.0435433,
                "odometer": 10602169,
                "timestamp": 1742799532
            },
            {
                "lat": 51.1305866,
                "lng": 17.0439083,
                "odometer": 10602197,
                "timestamp": 1742799537
            },
            {
                "lat": 51.1306766,
                "lng": 17.0442399,
                "odometer": 10602223,
                "timestamp": 1742799542
            },
            {
                "lat": 51.1307983,
                "lng": 17.0446066,
                "odometer": 10602252,
                "timestamp": 1742799547
            },
            {
                "lat": 51.1308116,
                "lng": 17.04468,
                "odometer": 10602257,
                "timestamp": 1742799548
            },
            {
                "lat": 51.1308,
                "lng": 17.0447483,
                "odometer": 10602262,
                "timestamp": 1742799549
            },
            {
                "lat": 51.1307666,
                "lng": 17.0448083,
                "odometer": 10602267,
                "timestamp": 1742799550
            },
            {
                "lat": 51.1307083,
                "lng": 17.044855,
                "odometer": 10602275,
                "timestamp": 1742799551
            },
            {
                "lat": 51.1303216,
                "lng": 17.04506,
                "odometer": 10602320,
                "timestamp": 1742799556
            },
            {
                "lat": 51.1299833,
                "lng": 17.0452949,
                "odometer": 10602361,
                "timestamp": 1742799561
            },
            {
                "lat": 51.1298933,
                "lng": 17.0453466,
                "odometer": 10602372,
                "timestamp": 1742799563
            },
            {
                "lat": 51.12981,
                "lng": 17.04535,
                "odometer": 10602381,
                "timestamp": 1742799565
            },
            {
                "lat": 51.1296533,
                "lng": 17.0452616,
                "odometer": 10602400,
                "timestamp": 1742799568
            },
            {
                "lat": 51.1292716,
                "lng": 17.0449316,
                "odometer": 10602448,
                "timestamp": 1742799573
            },
            {
                "lat": 51.1291033,
                "lng": 17.0449233,
                "odometer": 10602467,
                "timestamp": 1742799575
            },
            {
                "lat": 51.1288583,
                "lng": 17.0450233,
                "odometer": 10602496,
                "timestamp": 1742799578
            },
            {
                "lat": 51.1281966,
                "lng": 17.0454133,
                "odometer": 10602574,
                "timestamp": 1742799583
            },
            {
                "lat": 51.1279466,
                "lng": 17.0456383,
                "odometer": 10602605,
                "timestamp": 1742799588
            },
            {
                "lat": 51.1279433,
                "lng": 17.0456383,
                "odometer": 10602605,
                "timestamp": 1742799591
            },
            {
                "lat": 51.1279316,
                "lng": 17.0456033,
                "odometer": 10602608,
                "timestamp": 1742799593
            },
            {
                "lat": 51.1279133,
                "lng": 17.04554,
                "odometer": 10602613,
                "timestamp": 1742799594
            },
            {
                "lat": 51.1277083,
                "lng": 17.045045,
                "odometer": 10602655,
                "timestamp": 1742799599
            },
            {
                "lat": 51.1275666,
                "lng": 17.0444599,
                "odometer": 10602698,
                "timestamp": 1742799604
            },
            {
                "lat": 51.1275583,
                "lng": 17.0443983,
                "odometer": 10602703,
                "timestamp": 1742799605
            },
            {
                "lat": 51.12758,
                "lng": 17.0443733,
                "odometer": 10602706,
                "timestamp": 1742799606
            },
            {
                "lat": 51.1276166,
                "lng": 17.0443483,
                "odometer": 10602710,
                "timestamp": 1742799607
            },
            {
                "lat": 51.1276983,
                "lng": 17.0442966,
                "odometer": 10602720,
                "timestamp": 1742799610
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799615
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799620
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799625
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799630
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799635
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799640
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799645
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799650
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799655
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799660
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799665
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799670
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799675
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799680
            },
            {
                "lat": 51.1276916,
                "lng": 17.0442949,
                "odometer": 10602720,
                "timestamp": 1742799685
            }
        ]

      }
      // this.handleInputChange = this.handleInputChange.bind(this);
      // this.handleSubmit = this.handleSubmit.bind(this);
    //   this.changeActiveOrder = this.changeActiveOrder.bind(this);
    //   this.fetchApi = this.fetchApi.bind(this);
      this.onHover = this.onHover.bind(this);
  }

  onHover(e) {
    // console.log('hover', e);
    let features = e.features;
    let ftyp = (typeof features[0]).toString();
    // if(typeof features !== "undefined"){

    function closestLocation(targetLocation, locationData) {
        function vectorDistance(dx, dy) {
            return Math.sqrt(dx * dx + dy * dy);
        }
    
        function locationDistance(location1, location2) {
            var dx = location1.lat - location2.lat,
                dy = location1.lng - location2.lng;
    
            return vectorDistance(dx, dy);
        }
    
        return locationData.reduce(function(prev, curr) {
            var prevDistance = locationDistance(targetLocation , prev),
                currDistance = locationDistance(targetLocation , curr);
            return (prevDistance < currDistance) ? prev : curr;
        });
    }




    if (ftyp !== 'undefined') {
        // console.log('ftyp', typeof ftyp);
        // console.log('Defined');
        // console.log(e);
        // console.log('hover', e.features, e.features[0].layer.id, e.lngLat.lat, e.lngLat.lng);
        let pointx = e.point.x;
        let pointy = e.point.y;
        const targetLocation = {
            lat: e.lngLat.lat,
            lng: e.lngLat.lng,
        }
        let closest = closestLocation(targetLocation, this.state.points);
        // console.log('closest', closest)

        let val = {
            "x": pointx,
            "y": pointy,
            "closest": closest
        }
        this.setState({hoverInfo: val});

        // if(typeof e.features[0].layer.id !== "undefined"){
        // }
    } else {
        this.setState({hoverInfo: false});
    }
  }

  

//   fetchApi(currentorg) {
//     // let currentorg = localStorage.getItem('currentorg');
//     this.props.listOrders(currentorg, 'name', this.props.history);
//   }

  componentDidMount() {
    // let og = this.props.orgcurrent.list;
    // this.fetchApi(og);
    // this.timeout = setInterval(() => {
    //     og = this.props.orgcurrent.list;
    //     this.fetchApi(og);
    // }, 10000)
  }

  componentWillUnmount() {
    // clearTimeout(this.timeout);
  }

  componentDidUpdate(prevProps) {
    // if (prevState.orderdetails !== this.state.orderdetails) {
    //     console.log('Active order has changed.')
    //     this.setState({orderdetails: prevState.orderdetails.list});
    // }

    // if ( this.props.orders.list !== prevProps.orders.list ) {
    //     let id = this.props.orders.list[0];
    //     let id_old = prevProps.orders.list[0];
    //     if(id_old !== undefined) {
    //         id = id['_id'];
    //         id_old = id_old['_id'];
    //         if (id !== id_old){
    //             this.props.orderActiveId(id);
    //         }
    //     } else {
    //         if (id && id_old === undefined){
    //             this.props.orderActiveId(id);
    //         }
    //     }
    // }
    // if ( this.props.orgcurrent.list !== prevProps.orgcurrent.list ) {
    //     let og = this.props.orgcurrent.list;
    //     this.setState({currentorg: og});
    //     this.fetchApi(og);
    // }
}







    render() {
      const { errors } = this.state;
      const heading = 0;
      const marker_drive = '<svg version="1.1" id="Layer_1" style="transform: rotate('+heading+'deg);" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="12" height="12" '+
      'viewBox="0 0 77 77" enable-background="new 0 0 77 77" xml:space="preserve">'+
      '<path d="M72.7,77c-0.8,0-1.7-0.2-2.4-0.7L40.8,56.7c-1.4-0.9-3.3-0.9-4.7,0L6.6,76.3C4.6,77.5,2,77,0.7,75'+
      '	c-0.8-1.3-0.9-2.9-0.2-4.2L34.7,2.3c1.1-2.1,3.7-2.9,5.8-1.9c0.8,0.4,1.4,1.1,1.9,1.9l34.2,68.4c0.9,1.7,0.5,3.8-1,5.1'+
      '	C74.7,76.6,73.7,77,72.7,77z"/>'+
      '</svg>';


      


    let points = this.state.points;

    let arr = [];
    for (let i = 0; i < points.length; i++) {
        arr.push([
            points[i].lng,
            points[i].lat,
            points[i].odometer,
        ]);
    }


    // console.log('arr--------------');
    // console.log(arr);


    const dataOne = {
        type: "Feature",
        properties: {},
        geometry: {
            type: "LineString",
            coordinates: arr,
            // coordinates: [
            //     [17.0692733, 51.1456783],
            //     [17.0442949, 51.1276916]
            // ]
        }
    };

    let hoverInfo = this.state.hoverInfo;
      return (
          <div className="component workmap small-list">
            <div className="left">
                Mapa
            </div>
            <div className="right">
                <Map
                    className="map-wrapper"
                    mapboxAccessToken="pk.eyJ1IjoicGx1c2ZsZWV0IiwiYSI6ImNsOTVydTlvZDAxMmM0MG15bTVjMHlkMHEifQ.1fA73q5Vq8MaIKfgY3et1A"
                    initialViewState={{
                        longitude: 17.0442949,
                        latitude: 51.1276916,
                        zoom: 15,
                    }}
                    onMouseMove={this.onHover}
                    interactiveLayerIds={['linelayer']}
                    // onMouseMove={this.onHover.bind(this)}
                    mapStyle="mapbox://styles/mapbox/standard"
                    // mapStyle="mapbox://styles/mapbox/satellite-streets-v12"
                    // mapStyle="mapbox://styles/mapbox/navigation-day-v1"
                    >
                    <FullscreenControl />
                    <NavigationControl />
                    <ScaleControl />
                    {/* <Layer type="line" id="track00001" source="routes" /> */}


                    <Source id="polylineLayer" type="geojson" data={dataOne}>
                        <Layer
                            id="linelayer"
                            type="line"
                            source="my-data"
                            layout={{
                            "line-join": "round",
                            "line-cap": "round"
                            }}
                            paint={{
                            "line-color": "rgba(73, 61, 218, 0.7)",
                            "line-width": 5,
                            "line-opacity": [
                                "case",
                                ["boolean", ["feature-state", "hover"], true],
                                1,
                                0.9,
                              ]
                            }}
                            // filter={this.filter}
                        />
                    </Source>
                    {hoverInfo && (
                    <div className="tooltip" style={{left: hoverInfo.x, top: hoverInfo.y}}>
                        <div>State: {hoverInfo.closest.odometer}</div>
                    </div>
                    )}

                    <Marker longitude={17.0442949} latitude={51.1276916} anchor="bottom" >
                        <div className="direction_icon">
                        <svg width="40px" height="40px" viewBox="-4 0 36 36" version="1.1">

                            <g id="Vivid.JS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)">
                                    <g id="Icons" transform="translate(37.000000, 169.000000)">
                                        <g id="map-marker" transform="translate(78.000000, 468.000000)">
                                            <g transform="translate(10.000000, 6.000000)">
                                                <path d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z" id="Shape" fill="#FF6E6E">

                        </path>
                                                <circle id="Oval" fill="#0C0058" fillRule="nonzero" cx="14" cy="14" r="7">

                        </circle>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        </div>
                    </Marker>
                </Map>
            </div>
          </div>
      );
    }
}

// Orders.propTypes = {
//     addOrder: PropTypes.func.isRequired,
//     listOrders: PropTypes.func.isRequired,
//     orderActiveId: PropTypes.func.isRequired,
// };

const mapStateToProps = state => ({
    // orders: state.orders,
    // orgcurrent: state.orgcurrent,
    auth: state.auth,
    errors: state.errors,
    // orderdetailsactiveid: state.orderdetailsactiveid
});

export default connect(mapStateToProps)(withRouter(WorkMap))
